// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dOXmZ","wcomLogo":"styles_wcomLogo__2PMNk","promotionWrapper":"styles_promotionWrapper__uLxhJ","pridePromotion":"styles_pridePromotion__v21SC"};